import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetLegalDocumentAndVersionsQueryResponse, GetLegalDocumentAndVersionsPathParams, GetLegalDocumentAndVersions404, GetLegalDocumentAndVersions500 } from "../types/GetLegalDocumentAndVersions";

export const getLegalDocumentAndVersionsQueryKey = (type: GetLegalDocumentAndVersionsPathParams["type"], documentId: GetLegalDocumentAndVersionsPathParams["documentId"]) =>     [{url:`/api/documents/legal/${type}/${documentId}`,params:{type:type,documentId:documentId}}] as const;
      export function getLegalDocumentAndVersionsQueryOptions <TData = GetLegalDocumentAndVersionsQueryResponse, TError = GetLegalDocumentAndVersions404 | GetLegalDocumentAndVersions500>(type: GetLegalDocumentAndVersionsPathParams["type"], documentId: GetLegalDocumentAndVersionsPathParams["documentId"], options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getLegalDocumentAndVersionsQueryKey(type, documentId, );

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/documents/legal/${type}/${documentId}`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Запрос на получение документа
 * @link /api/documents/legal/:type/:documentId
 */

export function useGetLegalDocumentAndVersions <TData = GetLegalDocumentAndVersionsQueryResponse, TError = GetLegalDocumentAndVersions404 | GetLegalDocumentAndVersions500>(type: GetLegalDocumentAndVersionsPathParams["type"], documentId: GetLegalDocumentAndVersionsPathParams["documentId"], options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getLegalDocumentAndVersionsQueryKey(type, documentId, );

  const query = useQuery<TData, TError>({
    ...getLegalDocumentAndVersionsQueryOptions<TData, TError>(type, documentId, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
